<template>
  <div class="fillcontain">
    <top-header></top-header>
    <div class="search_container">
      <span style="padding: 0px">选择时间</span>
      <el-date-picker
        v-model="dateValue"
        type="datetimerange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['8:00:00','20:00:00']">
      </el-date-picker>
      <el-button type="primary" style="padding-left: 20px" @click="searchBtnClick">搜索</el-button>
    </div>
    <div class="table_container">
      <el-table
        :row-style="{height:'30px'}"
        :cell-style="{padding:'0px'}"
        :data="dataList"
        :header-cell-style="tableHeaderColor"
        style="width: 100%;font-size: 10px;">
        <el-table-column
          label="交易编号">
          <template slot-scope="props">
            <div style="text-align: center">
              <p>{{ props.row.id }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="交易类型">
          <template scope="props">
            <div style="text-align: center">
              <p> {{ props.row.way === '1' ? '消费' : props.row.way }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="支付方式">
          <template scope="props">
            <div style="text-align: center">
              <p> {{ props.row.paytype === '1' ? '余额' : '欠费' }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="消费类型">
          <template scope="props">
            <div style="text-align: center">
              <p> {{ formatCustomerType(props.row.consumetype) }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="课堂类型">
          <template scope="props">
            <div style="text-align: center">
              <p> {{ formatLiveScale(props.row.scale) }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="记账日期" width="150">
          <template slot-scope="props">
            <div style="text-align: center">
              <p>{{ props.row.ts }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="直播ID">
          <template slot-scope="props">
            <div style="text-align: right">
              <p>{{ props.row.liveid }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="在线人数">
          <template slot-scope="props">
            <div style="text-align: right">
              <p>{{ props.row.usernum }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="在线时长(秒)" >
          <template slot-scope="props">
            <div style="text-align: right">
              <p>{{ props.row.totalts }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="消费金额">
          <template slot-scope="props">
            <div style="text-align: right;color: #EE7E44">
              <p>-￥{{ props.row.money }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="剩余金额" style="text-align: right">
          <template slot-scope="props">
            <div style="text-align: right">
              <p>￥{{ props.row.rest }}</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="pageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import TopHeader from '../../components/TopHeader'
  export default {
    name: 'CostRecord',
    components: {TopHeader},
    data () {
      return {
        dataList: [],
        searchValue: '',
        dialogFormVisible: false,
        dateValue: [],
        currentPage: 1,
        pageCount: 10,
        totalCount: 0
      }
    },
    created () {

      let startDate = new Date(new Date().toLocaleDateString())
      let endDate =  new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)
      this.dateValue.push(startDate)
      this.dateValue.push(endDate)
      this.searchBtnClick()
    },
    watch: {
      '$route': {
        handler (route) {
          const that = this
          if (route.path === '/costrecord') {
            console.log('----', route.path)
            that.searchBtnClick()
          }
        },
        deep: true
      }
    },
    methods: {
      searchBtnClick () {
        if (this.dateValue.length > 1) {
          let startTime = this.formatDate('YYYY-mm-dd HH:MM:SS', this.dateValue[0])
          let endTime = this.formatDate('YYYY-mm-dd HH:MM:SS', this.dateValue[1])
          let requestData = {begints: startTime, endts: endTime, page: this.currentPage, count: this.pageCount}
          console.log(requestData)
          this.$api.recharge.getCostRecord(requestData).then((res) => {
            if (res.code === 0) {
              this.dataList = res.data
              this.totalCount = res.totalCount
            }
          })
          console.log(startTime)
        }
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this.searchBtnClick()
      },
      handleSizeChange (val) {
        this.pageCount = val
        this.currentPage = 1
        this.searchBtnClick()
      },
      formatLiveScale (type) {
        if (type === '0') {
          return '小班'
        } else if (type === '1') {
          return '大班'
        } else if (type === '3') {
          return '临时'
        } else if (type === '5') {
          return '双师'
        } else {
          return type
        }
      },
      formatCustomerType (type) {
        if (type === '1') {
          return '直播'
        } else if (type === '2') {
          return '回放'
        } else {
          return type
        }
      },
      formatDate (fmt, dateStr) {
        let date = new Date(dateStr)
        let ret
        let opt = {
          'Y+': date.getFullYear().toString(),
          'm+': (date.getMonth() + 1).toString(),
          'd+': date.getDate().toString(),
          'H+': date.getHours().toString(),
          'M+': date.getMinutes().toString(),
          'S+': date.getSeconds().toString()
        }
        for (let k in opt) {
          ret = new RegExp('(' + k + ')').exec(fmt)
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
          };
        };
        return fmt
      },
      tableHeaderColor(obj){
        // debugger
        if(obj.rowIndex === 0 && (obj.columnIndex === 6 || obj.columnIndex === 7 || obj.columnIndex === 8 || obj.columnIndex === 9 || obj.columnIndex === 10)) {
          return {background:'#eef1f6',color:'#606266',textAlign:'right'}
        }
        else{
          return {background:'#eef1f6', color:'#606266', textAlign:'center'}
        }
        // return {background:'#eef1f6',color:'#606266',textAlign:'center'}
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../style/mixin-bak";
  .search_container{
    width: 100%;
    padding-top: 10px;
    text-align: center;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    text-align: justify;
    margin-right: 0;
    margin-bottom: 0;
    width: 30%;
  }
  .table_container{
    padding: 20px;
  }
  .Pagination{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/page/financedManager/CostRecord.vue